import React from 'react';
import { Card, Typography, Space, Tag, Divider, Row, Col } from 'antd';
import { CustomerServiceOutlined, InfoCircleOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const ContactSupport: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <CustomerServiceOutlined style={{ marginRight: 8 }} />
              Contact Support
            </Title>
            <Tag color="green">Upcoming Feature</Tag>
          </div>
          
          <Divider />
          
          <div>
            <Title level={4}>Get Help & Support</Title>
            <Paragraph>
              This page will provide multiple ways to contact our support team.
              Features will include:
            </Paragraph>
            
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <Card size="small" title={<><MailOutlined /> Email Support</>}>
                  <Text>Send detailed inquiries via email with ticket tracking system.</Text>
                </Card>
              </Col>
              <Col span={8}>
                <Card size="small" title={<><PhoneOutlined /> Phone Support</>}>
                  <Text>Direct phone support during business hours with live assistance.</Text>
                </Card>
              </Col>
              <Col span={8}>
                <Card size="small" title={<><CustomerServiceOutlined /> Live Chat</>}>
                  <Text>Real-time chat support for immediate assistance and quick questions.</Text>
                </Card>
              </Col>
            </Row>
          </div>
          
          <div style={{ 
            background: '#f6ffed', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #b7eb8f'
          }}>
            <Space>
              <InfoCircleOutlined style={{ color: '#52c41a' }} />
              <Text type="secondary">
                Multiple support channels will be available to ensure you get the help you need quickly.
              </Text>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default ContactSupport;
